import { render, staticRenderFns } from "./uploadVideoOss.vue?vue&type=template&id=46ad6e61&scoped=true&"
import script from "./uploadVideoOss.vue?vue&type=script&lang=js&"
export * from "./uploadVideoOss.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideoOss.vue?vue&type=style&index=0&id=46ad6e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ad6e61",
  null
  
)

export default component.exports